// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-0f7bff6c]{margin:0;padding:0}h3[data-v-0f7bff6c],h4[data-v-0f7bff6c],h5[data-v-0f7bff6c],h6[data-v-0f7bff6c]{font-weight:400}.clear[data-v-0f7bff6c]{clear:both}body[data-v-0f7bff6c]{font-family:\"微软雅黑\"}a[data-v-0f7bff6c]{text-decoration:none;color:red}#echarts[data-v-0f7bff6c]{width:1000px;height:170%;margin:-70px auto 0 -150px;pointer-events:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
